/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q6Inputs */

const en_pc_faq_q6 = /** @type {(inputs: Pc_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it safe to install PdfCraft?`)
};

const zh_pc_faq_q6 = /** @type {(inputs: Pc_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装 PdfCraft 安全吗？`)
};

/**
* | output |
* | --- |
* | "Is it safe to install PdfCraft?" |
*
* @param {Pc_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q6 = /** @type {((inputs?: Pc_Faq_Q6Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q6Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q6(inputs)
	return zh_pc_faq_q6(inputs)
});
export { pc_faq_q6 as "pc.faq.q6" }